// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"118cc364","542":"cbdeefb5","625":"252bb9b6","996":"98c7febc"}[chunkId] + ".css";
};